import { HomeItemDetail } from '@app/modules/home-item-detail/entities/home-item-detail';
import { HomeFlightOffers } from '@shared/home-sections/entities/home-data.response';

export const homeItemDetailName = 'homeItemDetailModuleState';

export type UIHomeItemDetailState = Readonly<{
  isLoadingHomeItemDetail: boolean,
}>;

export type HomeItemDetailState = Readonly<{
  homeItemDetail: HomeItemDetail,
  ui: UIHomeItemDetailState,
  flightOffers: HomeFlightOffers[],
}>;

